import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  ViewChild,
} from '@angular/core';
import { FlexLayoutType } from '../../constants/flex-layout.type';
import { StatusType } from '../../constants/status.type';
import { StatusTextType } from '../../constants/status-text.type';
import { HearingMethodType } from '../../constants/hearing-method.type';
import { MatTableDataSource } from '@angular/material/table';
import { formatBytes } from '../../utils/format-bytes';
import { AssociatedMaterialModel } from '../../models/associated-materials.model';
import { AssociateSystemMaterialModel } from '../../models/associate-system-material.model';
import { UploadMaterialMetadataModel } from '../../models/document-metadata.model';
import { MatPaginator } from '@angular/material/paginator';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
@Component({
  selector: 'jsg-action-hearing-card-materials-view',
  templateUrl: './action-hearing-card-materials-view.component.html',
  styleUrls: ['./action-hearing-card-materials-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionHearingCardMaterialsViewComponent {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  private data: AssociatedMaterialModel[];
  get tableData(): AssociatedMaterialModel[] {
    return this.data;
  }
  @Input()
  set tableData(value: AssociatedMaterialModel[]) {
    this.data = value;
    this.dataSource = new MatTableDataSource(value);
    this.dataSource.paginator = this.paginator;

    this.createFormAssociatedMaterialsFormArray(value);
  }

  get fromAssociatedMaterialsFormAray(): FormArray {
    return this.form.get('associatedMaterials') as FormArray;
  }

  @Input() canAssociateMaterial: boolean;
  @Input() associateMaterialsSupportText: string;
  @Input() associateMaterialsEmptyText: string;

  @Output() associateMaterials = new EventEmitter();
  @Output() openFile = new EventEmitter<UploadMaterialMetadataModel>();
  @Output() downloadFiles = new EventEmitter<UploadMaterialMetadataModel[]>();

  displayedColumns: string[] = [
    'select',
    'fileName',
    'size',
    'materialType',
    'associatedBy',
    'dateFiled',
  ];
  dataSource = new MatTableDataSource<any>();

  public FlexLayoutType = FlexLayoutType;
  public formatBytes = formatBytes;
  public StatusType = StatusType;
  public StatusTextType = StatusTextType;
  public HearingMethodType = HearingMethodType;
  public allMaterialSelected: boolean = false;

  public form: FormGroup;

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      associatedMaterials: this.fb.array([]),
    });
    var x = this.fromAssociatedMaterialsFormAray.controls.some(
      (x) => x.get('selected').value == true
    );
  }

  private createSingleItem = (
    associatedMaterial: AssociatedMaterialModel
  ): FormGroup => {
    let formGroup = this.fb.group({
      selected: [false, Validators.required],
      document: [
        { value: associatedMaterial.document, disabled: true },
        Validators.required,
      ],
    });
    return formGroup;
  };

  private createFormAssociatedMaterialsFormArray = (
    systemMaterial: AssociatedMaterialModel[]
  ) => {
    systemMaterial?.forEach((item) => {
      this.fromAssociatedMaterialsFormAray.push(this.createSingleItem(item));
    });
  };

  public onAssociateMaterials = () => {
    this.associateMaterials.emit();
  };

  public onOpenFile = (docToOpen: AssociateSystemMaterialModel) => {
    this.openFile.emit(docToOpen.document);
  };

  public onDownloadFiles = () => {
    const selectedFilesControl = this.fromAssociatedMaterialsFormAray.controls.filter(
      (x) => x.get('selected').value == true
    );
    const selectedFiles = selectedFilesControl.map(
      (x) => new UploadMaterialMetadataModel(x.get('document').value)
    );
    if (selectedFiles.length > 0) {
      this.downloadFiles.emit(selectedFiles);
      selectedFilesControl.map((x) => {
        x.get('selected').setValue(false);
      });
    }
  };

  public getTotalPages = () => {
    let totalPages = 0;
    totalPages = this.tableData?.reduce(
      (sum, current) => sum + current.document.pages,
      0
    );
    return totalPages;
  };

  public isDownloadButtonDisabled = () => {
    return !this.fromAssociatedMaterialsFormAray.controls.some(
      (x) => x.get('selected').value == true
    );
  };

  public onRowClick = (rowIndex: number) => {
    const selectCheckBoxControl = this.fromAssociatedMaterialsFormAray
      .at(rowIndex)
      .get('selected');
    selectCheckBoxControl.setValue(!selectCheckBoxControl.value);
  };

  public selectAll = (completed: boolean) => {
    this.allMaterialSelected = completed;
    if (this.fromAssociatedMaterialsFormAray?.length == 0) {
      return;
    }
    for (
      let index = 0;
      index < this.fromAssociatedMaterialsFormAray.length;
      index++
    ) {
      const selectCheckBoxControl = this.fromAssociatedMaterialsFormAray
        .at(index)
        .get('selected');
      selectCheckBoxControl.setValue(completed);
    }
  };

  public someSelected = (): boolean => {
    if (this.fromAssociatedMaterialsFormAray?.length == 0) {
      return;
    }
    return (
      this.fromAssociatedMaterialsFormAray.controls.filter(
        (t) => t.get('selected').value
      ).length > 0 && !this.allMaterialSelected
    );
  };

  public updateAllSelected = () => {
    this.allMaterialSelected =
      this.fromAssociatedMaterialsFormAray?.length > 0 &&
      this.fromAssociatedMaterialsFormAray.controls.every(
        (t) => t.get('selected').value
      );
  };
}
